module.exports = __webpack_public_path__ + "static/media/24 - Dram - Broccoli (feat. Lil Yachty).57d571e8.mp3";